import script from "./ScannerCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./ScannerCapture.vue?vue&type=script&setup=true&lang=js"

import "./ScannerCapture.vue?vue&type=style&index=0&id=591c9bf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591c9bf8"]])

export default __exports__